import type { ReactElement } from 'react';

export function MasterSearchField({
  value,
  onChange,
  placeholder = 'Name, API, or identifier'
}: {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
}): ReactElement {
  return (
    <div className="row filter-row">
      <label>
        Search
        <input value={value} onChange={(e) => onChange(e.target.value)} placeholder={placeholder} />
      </label>
    </div>
  );
}
